module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_purebarre-308ecbb4d5f048ee0bd2b193f089bec3.svg";